<template>
    <div class="m-ccfwawa" :class="'step_'+step">
        <div class="m-ccfwawa--pre"></div>
        <div class="m-ccfwawa--img absolute"></div>
        <Dialog :type="type" :content="contents"></Dialog>
    </div>
</template>

<script>
import Dialog from './Dialog.vue'
export default {
  name: 'Ccfwawa',
  props: {
    step: Number // step
  },
  components: {
    Dialog
  },
  watch: {
    step: {
      handler: function () {
        this.contents = this.dialogs[this.step + 3].content
        this.wawa = this.wawaSource[this.step + 3]
        if (this.step !== -3) {
          this.type = 'white'
        }
        if (this.step === 0) {
          this.contents = this.$parent.form.nickname + ' ' + this.dialogs[this.step + 3].content
        }
        if (this.step === 2 || this.step === 3 || this.step === 8) {
          if (this.$parent.form.type === 'child') {
            this.contents = this.dialogs[this.step + 3].child.content
          } else {
            this.contents = this.dialogs[this.step + 3].parent.content
          }
        }
        if (this.step === 12) {
          this.contents = '感謝 ' + this.$parent.form.nickname + ' ' + this.dialogs[this.step + 3].content
        }
      }
    }
  },
  data () {
    return {
      dialogs: [
        {
          content: 'Hi~我是家扶WaWa，<br>將陪伴你一起蒐集葉子喔！'
        },
        {
          content: '開始之前，請輸入你的暱稱吧～'
        },
        {
          content: null // 選身份
        },
        {
          content: '你好，請輸入年齡～' // 輸入年齡
        },
        {
          content: '這不是考試、也沒有對錯<br>移動樹懶來選擇最貼近您的感受' // 第一題
        },
        {
          child: {
            content: '家人關心你的考試成績、在校表現…'
          },
          parent: {
            content: '你對孩子在學校的表現與學業成績滿意嗎？'
          }
        },
        {
          child: {
            content: '對於家人提醒你早睡早起、注意<br>安全、不要挑食、幫忙家事等…'
          },
          parent: {
            content: '孩子可自動自發?或需要一直督促嗎？'
          }
        },
        {
          content: '可以按住松果放入樹洞唷～'
        },
        {
          content: null
        },
        {
          content: null
        },
        {
          content: '可以拉動貓頭鷹回答問題喔！'
        },
        {
          child: {
            content: '家人會無緣無故的對你生氣嗎?'
          },
          parent: {
            content: '本來心情就煩躁，再遇到<br>孩子吵鬧，管教受到影響情形'
          }
        },
        {
          content: '加油，神秘動物就要出現了！'
        },
        {
          content: null
        },
        {
          content: '最後一題囉！'
        },
        {
          content: '通過森林看到屬於你的動物，參考建議可助於更好的家庭關係'
        }
      ],
      wawaSource: [
        'ccf-wawa-1.png',
        'ccf-wawa-2.png',
        'ccf-wawa-3.png',
        'ccf-wawa-4.png',
        'ccf-wawa-5.png',
        'ccf-wawa-6.png'
      ],
      wawa: 'ccf-wawa-1.png',
      contents: 'Hi~我是家扶WaWa，<br>將陪伴你一起蒐集葉子喔！',
      type: 'green'
    }
  },
  mounted () {
  }
}
</script>

<style scoped lang="scss">
@keyframes play {
   from { background-position:    0px; }
     to { background-position: -6020px; }
}
.m-ccfwawa{
    position: absolute;
    width: 430px;
    height: 480px;
    bottom: 0;
    left: 0;
    z-index: 5;
    pointer-events: none;
    &--pre{
      height: 0;
      width: 0;
      display: inline;
      background-image: url(~@/assets/ccf-wawa-1-a.png);
      background-image: url(~@/assets/ccf-wawa-2-a.png);
      background-image: url(~@/assets/ccf-wawa-3-a.png);
      background-image: url(~@/assets/ccf-wawa-4-a.png);
      background-image: url(~@/assets/ccf-wawa-5-a.png);
    }
    &--img{
      height: 100%;
      width: 100%;
      // top: 0;
      // left: 0;
      top: 10%;
      left: -15%;
      transform: scale(0.5);
      transform-origin: bottom left;
      transition: .4s ease-in-out;
    }
    @include respond-to(sm) {
      bottom: -25px;
      &--img{
        left: -10%;
        transform: scale(0.7);
      }
    }
     @include respond-to(md) {
       bottom: 0px;
     }
    @include respond-to(xl) {
      left: 50px;
       &--img{
        left: -10%;
        transform: scale(1);
      }
    }
    &.step_-3,
    &.step_5,
    &.step_6,
    &.step_10,
    &.step_12{
      .m-ccfwawa--img{
        animation: play 5.5s steps(14) infinite alternate;
        background-image: url(~@/assets/ccf-wawa-1-a.png);
      }
    }
    &.step_-2,
    &.step_-1,
    &.step_0,
    &.step_11{
      .m-ccfwawa--img{
        animation: play 1.5s steps(14) infinite forwards;
        background-image: url(~@/assets/ccf-wawa-2-a.png);
      }
    }
    &.step_1,
    &.step_2,
    &.step_3,
    &.step_4,
    &.step_7{
      .m-ccfwawa--img{
        animation: play 2.2s steps(14) infinite forwards;
        background-image: url(~@/assets/ccf-wawa-3-a.png);
      }
    }
    &.step_8{
      .m-ccfwawa--img{
        animation: play 2.5s steps(14) infinite forwards;
        background-image: url(~@/assets/ccf-wawa-4-a.png);
      }
    }
    &.step_9{
      .m-ccfwawa--img{
        animation: play 2.2s steps(14) infinite forwards;
        background-image: url(~@/assets/ccf-wawa-5-a.png);
      }
    }
}

</style>
